import { z } from "zod";
import { allEventSchemas } from "./features/index.js";
export * from "./base.js";
export * from "./features/index.js";
/**
 * Runtime contract for rows written to the append-only `EventLogs` table.
 *
 * One schema serves both sides: `azure-functions` is plain JS and gets validation it
 * otherwise has no types for, and the frontend gets the inferred TypeScript types. Without
 * this the shape of `metadata` lived only in whatever each call site happened to pass, and
 * readers had to reverse-engineer it per event type.
 *
 * Discriminated on `eventType`, which is what makes the per-feature metadata shapes
 * enforceable: a `BILLING_CANCELLATION_POLICY_APPLIED` row must carry a policy and an
 * evaluation, while a reverted row must carry neither. A single permissive metadata object
 * could not say that, and every reader would be back to guessing.
 *
 * The members come from `./features`, so adding an event never means editing this file.
 */
export const eventLogRecordSchema = z.discriminatedUnion("eventType", [
    ...allEventSchemas,
]);
//# sourceMappingURL=index.js.map